import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody, Row, Col, FormGroup, Input, Label, Progress, InputGroup } from 'reactstrap';
import Dropzone from 'react-dropzone';
import CloudUpload from '@mui/icons-material/CloudUploadOutlined'
import CloudDone from '@mui/icons-material/CloudDoneOutlined'
import Error from '@mui/icons-material/ErrorOutline'

class DocumentTypeValidationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      runActions: false,
      selectedDocument: [],
      dropComplete: false,
      dropError: false,
      dropMessage: ''
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.selectedDocument && this.state.selectedDocument !== prevState.selectedDocument) {
      this.testDocument();
    }
  }

  onDragEnter = () => {
    this.setState({
      dropzoneActive: true
    });
  }

  onDragLeave = () => {
    this.setState({
      dropzoneActive: false
    });
  }

  onDrop = (files) => {
    this.setState({
      selectedDocument: files,
      // selectedFileName: files[0].name,
      dropzoneActive: false
    });
  }

  runActionsCheckChanged = (e) => {
    const target = e.target;
    const value = target.checked;
    this.setState({
      runActions: value
    })
  }

  testDocument = () => {
    const { documentType, fields, folder } = this.props;

    var data = new FormData();
    //apend the file and then the meta data as seperate parms
    data.append("document", this.state.selectedDocument[0]);
    data.append("documentType", documentType);
    data.append("folder", folder);
    data.append("runActions", this.state.runActions);
    data.append("fields", fields);

    fetch(window.location.protocol + '//' + window.location.host + "/api/processing/test_process_document", {
      method: "POST",
      body: data
    })
      .then(res => res.json())
      .then(result => {
        this.setState({
          dropComplete: true,
          dropError: result.error,
          dropMessage: result.message
        })
      })
      .catch((error) => {
        this.setState({
          dropComplete: true,
          dropMessage: error.message
        })
      });
  }

  render() {
    const { parsed, userReducer } = this.props;
    const { localisation } = userReducer;

    const overlayStyle = {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      padding: '100px 20px',
      textAlign: 'center',
      fontSize: '2em',
      color: '#5f6368',
      backgroundColor: this.state.dropzoneActive ? '#f5f5f5' : '#fff',
      outline: '2px dashed #5f6368',
      outlineOffset: '-10px'
    };

    return (
      <Modal isOpen={this.props.visible} toggle={this.props.toggle} className='modal-dialog'>
        <ModalHeader toggle={this.props.toggle}>{localisation['doc_type_validation_header'] ? localisation['doc_type_validation_header'].element_lang : 'Drop document for validation'}</ModalHeader>
        <ModalBody>
          <Dropzone
            style={{ position: "relative", width: 800, height: 400 }}
            accept=".pdf,.jpg,.png"
            onDrop={this.onDrop}
            onDragEnter={this.onDragEnter}
            onDragLeave={this.onDragLeave}
          >
            {this.state.dropComplete ?
              <>
                <div style={overlayStyle}>
                  {this.state.dropError ?
                    <><Error fontSize={'inherit'} style={{ fontSize: '4rem' }} />
                      <p><strong>Document test error</strong> {this.state.dropMessage} </p>  </>
                    :
                    <><CloudDone fontSize={'inherit'} style={{ fontSize: '4rem' }} />
                      <p><strong>Document test complete</strong> {this.state.dropMessage} </p></>
                  }
                </div>
              </>
              :
              <>
                <div style={overlayStyle}>
                  <CloudUpload fontSize={'inherit'} style={{ fontSize: '4rem' }} />
                  <p><strong>Choose a file</strong> or drag it here.</p>
                </div>
              </>
            }
          </Dropzone>
          <ModalFooter>
            <FormGroup check>
              <Label for="runActions" className="s-field-title s-anchored">
                <Input type="checkbox" name={'runActions'} checked={this.state.runActions} onClick={this.runActionsCheckChanged} />{' '}
                Run Actions
              </Label>
            </FormGroup>
            <Button color="secondary" onClick={this.props.toggle}>{localisation['close_button'] ? localisation['close_button'].element_lang : ''}</Button>
          </ModalFooter>
        </ModalBody>
      </Modal>
    );
  }
}
export default connect(state => state)(DocumentTypeValidationModal);
